import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'currency-markets' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
